import { createSignal, For } from "solid-js";
import { Portal } from "solid-js/web";

type ToastKind = "success" | "error";
type ToastItem = { id: number; message: string; kind: ToastKind };

const DISMISS_AFTER_MS = 3000;

const [items, setItems] = createSignal<ToastItem[]>([]);
let nextId = 0;

/** Shows a transient message. Callable from anywhere, including outside a component. */
export function toast(message: string, kind: ToastKind = "success") {
  const id = nextId++;
  setItems((current) => [...current, { id, message, kind }]);
  setTimeout(
    () => setItems((current) => current.filter((item) => item.id !== id)),
    DISMISS_AFTER_MS,
  );
}

/** Renders the toast stack. Mount once, near the root. */
export function Toaster() {
  return (
    <Portal>
      <For each={items()}>
        {(item) => <div class={`toast ${item.kind}`}>{item.message}</div>}
      </For>
    </Portal>
  );
}
